import { useState } from "preact/hooks"
import Leaderboard from "src/components/Leaderboard"

import { Modal, ModalWrapper } from "src/utils/fw"
import assets from "../assets"
import { userID, userName } from "src/utils/datalayer"


export const LeaderboardPopup = () => {
    const [isOpen, setOpen] = useState(false)
    const {
        "Event ID": eventId,
        "Registrant ID": regId,
        "I would like to opt in to the Leaderboard competition": optedIn,
    } = window.dataLayer[0]

    return <><div id="Leaderboard" onclick={() => setOpen(true)} />
        {isOpen &&
            <Modal dismiss={(e) => {
                console.log("dismiss")
                setOpen(false)
            }} dismissHTML="X">
                <ModalWrapper wrapperStyle={{background: "none", minHeight: "600px"}}>
                    <Leaderboard 
                        eventId={assets.eventId}
                        userId={userID}
                        name={userName}
                        hideClose
                        hidePodium
                        hideButtons
                        achievementsOpen={false}
                        quantity={11}
                        entrypoint="https://leaderboardb.swoogo-retrofit.tkevents.io"
                    />
                </ModalWrapper>
            </Modal>
        }
    </>
}

export const HowToEarnPoints = () => {
    const [open, setOpen] = useState(false);

    return <>
        <div id="leaderboardTutorial" onClick={() => setOpen(true)} />
        { open && <Modal dismiss={() => setOpen(false)} dismissHTML="X">
            <ModalWrapper wrapperStyle={{background: "none", color: "white", textAlign: "center", fontSize: "16px", maxWidth: "800px"}} >
                <h1>Leaderboard: How to Earn Points</h1>
                <p>Explore the platform for your chance to win! Participate in activities across the platform to gain points. Top scorers will win prizes.</p>
                <p>
                    If you have not opted-in to the Attendee Directory, you will not take part in the leaderboard or receive any points. 
                    To opt-in, <a target="_blank" href="https://events.securityforum.org/isfcongress2025/begin" style={{
                        color: "white",
                        fontWeight: "bold",
                        fontStyle:"italic",
                        textDecoration: "underline"
                    }}>please modify your registration here and opt-in to the Attendee Directory.</a>
                </p>
                <p style={{fontStyle: "italic"}}>All winners will be contacted after the event.</p>
                <hr />
                <h2>HOW TO EARN POINTS</h2>
                <div style={{display: "flex", width: "100%", alignItems: "center", flexDirection: "column", gap: "30px"}}>
                    <ul style={{textAlign: "left", maxWidth: "500px"}}>
                        <li>View keynote presentation - 75 points</li>
                        <li>View breakout presentation - 50 points</li>
                        <li>View on-demand presentation - 50 points</li>
                        <li>
                            Provide session feedback - 20 points - <em>Please provide feedback
                            immediately following each session to receive your points</em>
                        </li>
                        <li>
                            Watch ISF video in Exploration Zone - 40 points per item, per video
                        </li>
                        <li>
                            Listen to ISF podcast in Exploration Zone - 40 points per day, per podcast
                        </li>
                        <li>Download content from Exploration Zone - 20 points per item</li>
                        <li>
                            Watch exhibition stand video - 40 points per item, per video
                        </li>
                        <li>Download exhibitor brochure - 20 points per item</li>
                        <li>Click on exhibitor logo – 10 points per company</li>
                        <li>Contact an exhibitor – 20 points per company</li>
                    </ul>
                    <button className="CTABTN" onClick={() => setOpen(false)}>Got it</button>
                </div>
            </ModalWrapper>
        </Modal> }
    </>
}